import http from "../../http-common";

const login = (data) => http.post("/User/Login", data);

const getSystemParameterList = (data) => http.get("/SystemParameter/GetSystemParameterListForLogin", data);

const getAuthenticatedUser = () => http.get("/User/Authenticated");

export default { login, getSystemParameterList, getAuthenticatedUser };